'use client';

import React from 'react';
import { useGlobalClientContext } from '../../common/GlobalClientContext';
import observability from '../../../../public/images/observability-1.png';
import { convertNewLinesToBrs } from '@altus-ui/components_v2/utils/text';

export default function Product() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();

  const feature1Desc = t('public.site.product.observability.feature1.desc', {});
  return (
    <>
      <div className="flex flex-[1] flex-col items-center gap-3xl mb-9xl text-center">
        <div className="text-5xl leading-18xl text-gray-900 font-semibold whitespace-nowrap">
          {t('public.site.product.observability.feature', {})} <br />
          {t('public.site.product.observability.feature1', {})}
        </div>
        <div className="text-xl font-regular leading-3xl text-gray-600 text-center">
          {convertNewLinesToBrs(feature1Desc)}
        </div>
      </div>
      <img src={observability.src} alt="observability" />
      <div className="flex flex-row mt-9xl px-[125px] gap-9xl">
        <div className="flex flex-1 flex-col gap-2xs w-[480px]">
          <div className="text-xl font-semibold leanding-lg text-primary">
            {t('public.site.product.observability.feature2', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.observability.feature2.desc', {})}
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-2xs w-[480px]">
          <div className="text-xl font-semibold leanding-lg text-primary">
            {t('public.site.product.observability.feature3', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.observability.feature3.desc', {})}
          </div>
        </div>
      </div>
    </>
  );
}
